import React, { Component } from "react";
import { Image, TouchableOpacity, View, Dimensions } from "react-native";
import TextView from "./TextView";
import { icons } from "../theme/icons";
import { componentStyles, appStyles } from "../theme/styles";
import { blueDarkColor, blueLightColor} from "../theme/colors";
import LinearGradient from 'react-native-linear-gradient';
import { priceString, persianNumber, showPrompt } from "../utils/utils";
import EditText from "./EditText";
import { wp} from "../utils/responsive";
import DialogList from "./DialogList";
var { width, height } = Dimensions.get('window');
export default class CartItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            number: props.data.number.toString()
        }
    }
    componentWillReceiveProps(newprops) {
        this.setState({
            number: newprops.data.number.toString()
        })

    }

    render() {
        var item = this.props.data;
        return (
            <View style={componentStyles.cartItem}>

                <View style={[appStyles.rowBetween, { flex: 1, width: wp(70) }]}>
                    <View>
                        <TouchableOpacity style={[{ margin: 5, width: 34, height: 34, borderRadius: 12, backgroundColor: '#FF6555' }, appStyles.center]} onPress={() => {
                            showPrompt('حذف آیتم', 'آیا نسبت به حذف این آیتم اطمینان دارید؟', () => {
                                this.props.onRemove()
                            })

                        }}>
                            <Image source={icons['remove']} style={[componentStyles.smallIconWhite, { marginLeft: 0 }]} />
                        </TouchableOpacity>
                        <TextView numberOfLines={1} style={{ margin: 5, fontSize: 12, maxWidth: 100, textAlign: 'center' }}>تعداد</TextView>
                        <View style={[appStyles.row, appStyles.center]}>
                            <TouchableOpacity style={[{ width: 30, height: 30, borderRadius: 15, backgroundColor: '#DCB555' }, appStyles.center]} onPress={() => {

                                if (item.number > 1) {
                                    this.props.onChange(item.number - 1);
                                }


                            }}>
                                <TextView style={{ color: 'white', fontSize: 18 }}>-</TextView>
                            </TouchableOpacity>
                            {item.sessions != null && item.sessions.length > 0 ?
                                <TouchableOpacity style={{ padding: 5 }} onPress={() => {
                                    this.setState({
                                        showModal: true
                                    })
                                }}>
                                    <TextView style={{ margin: 15 }}>{persianNumber(item.number)}</TextView>
                                </TouchableOpacity> :
                                <EditText
                                    hint=''
                                    inputType='numeric'
                                    textStyle={{ color: 'black', width: wp(10) }}
                                    style={[appStyles.textInput, { width: wp(10) }]}
                                    onChangeText={(text) => {
                                        this.setState({
                                            number: text
                                        })
                                        if (text.length > 0) {
                                            this.props.onChange(parseInt(text));
                                        }
                                    }}
                                    value={this.state.number} />}

                            <TouchableOpacity style={[{ width: 30, height: 30, borderRadius: 15, backgroundColor: '#31BDCC' }, appStyles.center]} onPress={() => {

                                this.props.onChange(item.number + 1);


                            }}>
                                <TextView style={{ color: 'white', fontSize: 18 }}>+</TextView>
                            </TouchableOpacity>
                        </View>
                    </View>
                    <View style={{ width: wp(28) }}>
                        <TextView numberOfLines={1} style={[appStyles.rightText, { marginBottom: 5, maxWidth: width / 3 }]}>{item.title}</TextView>
                        {item.noshow_price == 0 ? <TextView style={[appStyles.rightText, { marginBottom: 5, fontSize: 12, marginTop: 5, color: '#4D4C53' }]}>قیمت : {priceString(item.price)} تومان</TextView> : null}
                        {item.noshow_price == 0 ? <TextView style={[appStyles.rightText, { marginBottom: 5, fontSize: 12, marginTop: 5, color: '#4D4C53' }]}>قیمت کل : {priceString(item.price * item.number)} تومان</TextView> : null}
                        {/* <TextView style={[appStyles.rightText, { marginBottom: 5, fontSize: 12, marginTop: 10, color: item.have_insurance ? greenDarkColor : redColor }]}>{item.have_insurance ? 'این خدمت شامل بیمه می باشد' : 'این خدمت شامل بیمه نمی باشد'}</TextView> */}
                    </View>

                </View>
                <LinearGradient colors={[blueDarkColor, blueLightColor]} style={componentStyles.cartImageWraper}>
                    <Image
                        source={{ uri: item.imageurl }}
                        style={componentStyles.serviceImage} />
                </LinearGradient>
                <DialogList
                    show={this.state.showModal}
                    title='تعداد جلسه'
                    field='topic'
                    data={item.sessions}
                    onSelect={(item, index) => {
                        this.setState({
                            showModal: false,
                        }, () => {
                            this.props.onChange(item.number);
                        })

                    }}
                    onCancel={() => {
                        this.setState({
                            showModal: false
                        })
                    }} />
            </View>
        );
    }
}


